import React from "react";
import "./Breadcrumbs.scss";
import { useIcon } from "../../design-system/assets/useIcon";
import type { Integration } from "./Breadcrumbs";

interface BreadcrumbIntegrationLabelIntegration extends Integration {
  imageShort?: string;
  iconName?: string;
}

interface BreadcrumbIntegrationLabelProps {
  integration?: BreadcrumbIntegrationLabelIntegration;
}

const BreadcrumbIntegrationLabel: React.FC<BreadcrumbIntegrationLabelProps> = ({
  integration,
}) => {
  const { name, imageShort, iconName } = integration || {};
  const { getDataSourceIcon } = useIcon();

  // Prefer the theme-aware icon map; `imageShort` is a single backend URL
  // (no dark variant), so it's only a fallback when the map has no entry.
  // getDataSourceIcon returns a plain string URL when called with a size ("S").
  const icon =
    (getDataSourceIcon(iconName || name, "S", true) as string | undefined) ||
    imageShort;

  return (
    <span className={"breadcrumb-integration-label"}>
      {!!icon && (
        <img
          className={"breadcrumb-integration-label-icon"}
          src={icon}
          alt="integration-icon"
        />
      )}
      {name}
    </span>
  );
};

export default BreadcrumbIntegrationLabel;
